import { InputAdornment } from "@mui/material";
import { DatePicker, CalendarIcon } from "@mui/x-date-pickers";
import moment from "moment";
import React, { useState } from "react";

const DateSelector = ({
  value,
  name,
  small = true,
  onChange,
  onChangeValue,
  minDate,
  maxDate,
  disabled,
  isGroupField = false,
  format = "DD/MM/YYYY",
}) => {
  const dateValue = moment(value, format);
  const [open, setOpen] = useState(false);

  const onChangeDate = (newValue) => {
    if (typeof onChange == "function") {
      const formattedDate = newValue.toDate();
      onChange({
        target: {
          name: name,
          value: formattedDate,
        },
      });
    }

    if (typeof onChangeValue == "function") {
      const formattedDate = newValue.toDate();
      onChangeValue(formattedDate);
    }
  };

  return (
    <DatePicker
      open={open}
      value={dateValue}
      onChange={onChangeDate}
      minDate={minDate}
      maxDate={maxDate}
      disabled={disabled}
      onClose={() => setOpen(false)}
      format={format}
      slotProps={{
        textField: {
          error: false,
          onClick: () => !disabled && setOpen(true),
          InputProps: {
            endAdornment: (
              <InputAdornment position="end">
                <CalendarIcon />
              </InputAdornment>
            ),
          },
        },
        openPickerIcon: {
          onClick: () => {
            !disabled && setOpen(true);
          },
        },
      }}
      sx={{
        "& .MuiInputBase-root": {
          height: small ? "42px" : "56px",
          "& input": {
            paddingLeft: isGroupField ? 0 : undefined,
            color: value ? "#111" : "#8e8e8e",
          },
          "& fieldset": {
            borderWidth: isGroupField ? 0 : 1,
            borderColor: "#CBCAD7",
            borderRadius: "0.375rem",
          },
          "&.Mui-focused fieldset": {
            borderWidth: isGroupField ? 0 : 1,
            borderColor: "#CBCAD7",
            borderRadius: "0.375rem",
          },
          "&:hover fieldset": {
            borderWidth: isGroupField ? 0 : 1,
            borderColor: "#CBCAD7",
            borderRadius: "0.375rem",
          },
        },
        width: "100%",
      }}
    />
  );
};

export default DateSelector;
